var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86678594-8392-452E-8812-8315EBA322F4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onboarding---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/traits-answered",
    transform: "translate(-700.000000, -275.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pill-copy-2",
    transform: "translate(559.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16px/close/gray",
    transform: "translate(141.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.112441875,7.88755813 C-0.0306940631,7.74442219 -0.0306940631,7.51235298 0.112441875,7.36921704 L3.48165892,4 L0.0957391315,0.614080215 C-0.0381721359,0.480168947 -0.0306940631,0.255577812 0.112441875,0.112441875 C0.255577812,-0.0306940631 0.480168947,-0.0381721359 0.614080215,0.0957391315 L4,3.48165892 L7.36921704,0.112441875 C7.51235298,-0.0306940631 7.74442219,-0.0306940631 7.88755813,0.112441875 C8.03069406,0.255577812 8.03069406,0.48764702 7.88755813,0.630782958 L4.51834108,4 L7.90426087,7.38591979 C8.03817214,7.51983105 8.03069406,7.74442219 7.88755813,7.88755813 C7.74442219,8.03069406 7.51983105,8.03817214 7.38591979,7.90426087 L4,4.51834108 L0.630782958,7.88755813 C0.48764702,8.03069406 0.255577812,8.03069406 0.112441875,7.88755813 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d1e21e4a284527ea1b1bc42caffbe78a.svg";
export { ForwardRef as ReactComponent };